import { SessionTokens, SessionTokensApi } from "../../types";

export const accessTokenSerializer = async (response: Response): Promise<SessionTokens> => {
  const data: SessionTokensApi = await response.json();
  return {
    accessToken: data.access_token,
    refreshToken: data.refresh_token,
    expiresAt: data.expires_in * 1000 + Date.now(),
  };
};
